export const environment = {
   version: '1.0.1',
   production: false,
   apiBaseUrl: 'https://app-delivery-service-api-dev-use2.azurewebsites.net/',
   apiPathPrefix: 'api/v1',
   consumerIdentityClientId: 'pedemais',
   consumerIdentityOrigin: 'LOYALTYPROGRAM',
};
